/**
 * Compute YES/NO stakes for a given date string (YYYY-MM-DD)
 * Mirrors backend _points_for logic:
 *  - Challenge day (in challenge_days_this_month for that month) → YES=+30, NO=0
 *  - Weekend (Sat/Sun) → YES=+20, NO=-20
 *  - Weekday → YES=+10, NO=-10
 */
export function stakesForDate(dateIso, challengeInfo) {
  if (!dateIso) return { yes: 10, no: -10, isWeekend: false, isChallenge: false };
  const d = new Date(dateIso + "T00:00:00");
  const dow = d.getDay(); // 0=Sun, 6=Sat
  const isWeekend = dow === 0 || dow === 6;

  // Determine if this date is a challenge day. challengeInfo only contains
  // challenge_days_this_month for the *current* month, so apply only when
  // the selected date's month matches.
  let isChallenge = false;
  if (challengeInfo?.challenge_days_this_month?.length && challengeInfo?.year && challengeInfo?.month) {
    if (d.getFullYear() === challengeInfo.year && d.getMonth() + 1 === challengeInfo.month) {
      isChallenge = challengeInfo.challenge_days_this_month.includes(d.getDate());
    }
  }

  if (isChallenge) return { yes: 30, no: 0, isWeekend, isChallenge: true };
  if (isWeekend) return { yes: 20, no: -20, isWeekend: true, isChallenge: false };
  return { yes: 10, no: -10, isWeekend: false, isChallenge: false };
}
